import { BreadcrumbItemProps } from '@commenda/kakashi';
import { useRouter } from 'next/router';
import { ExemptionCertificateFormMode } from '../types';

export const useNavigationConfigForExemptionCertificateForm = ({
  mode,
  customerName = 'Customer',
  certificateName = 'Certificate',
  corporationId,
  customerId,
}: {
  mode: ExemptionCertificateFormMode;
  customerName: string;
  certificateName: string;
  corporationId: string;
  customerId: string;
}) => {
  let items: BreadcrumbItemProps[] = [];

  if (mode === ExemptionCertificateFormMode.CREATE) {
    items = [
      {
        label: 'Sales Tax',
        href: `/sales-tax/${corporationId}/exemptions`,
      },
      {
        label: 'Customers',
        href: `/sales-tax/${corporationId}/exemptions`,
      },
      ...(customerId
        ? [
            {
              label: customerName,
              href: `/sales-tax/customer/${customerId}?corporationId=${corporationId}`,
            },
          ]
        : []),

      {
        label: 'Add exemption',
        href: null,
      },
    ];
  } else {
    items = [
      {
        label: 'Sales Tax',
        href: `/sales-tax/${corporationId}/exemptions`,
      },
      {
        label: 'Customers',
        href: `/sales-tax/${corporationId}/exemptions`,
      },
      {
        label: customerName,
        href: `/sales-tax/customer/${customerId}?corporationId=${corporationId}`,
      },
      {
        label: certificateName,
        href: null,
      },
    ];
  }

  return items;
};

export const useNavigationConfigForExemptCustomerForm = ({
  customerName = 'Customer',
  corporationId,
}: {
  customerName: string;
  corporationId: string;
}) => {
  const items: BreadcrumbItemProps[] = [
    {
      label: 'Sales Tax',
      href: `/sales-tax/${corporationId}/exemptions`,
    },
    {
      label: 'Customers',
      href: `/sales-tax/${corporationId}/exemptions`,
    },
    {
      label: customerName,
      href: null,
    },
  ];

  return items;
};

export const useNavigationConfigForFilings = ({
  filingName = 'Filings',
  corporationId,
  isAgent = false,
}: {
  corporationId: string;
  filingName: string;
  isAgent?: boolean;
}) => {
  const router = useRouter();

  const clientAppNavigationConfig = [
    {
      label: 'Sales Tax',
      href: `/sales-tax/${corporationId}/filings`,
    },
    {
      label: 'Filings',
      href: `/sales-tax/${corporationId}/filings`,
    },
    {
      label: filingName,
      href: null,
    },
  ];

  const agentAppNavigationConfig = [
    {
      label: 'Clients',
      href: '/clients',
    },
    {
      label: 'Filings',
      href: `/clients/${corporationId}/sales-tax-filings`,
    },
    {
      label: filingName,
      href: null,
    },
  ];

  return isAgent ? agentAppNavigationConfig : clientAppNavigationConfig;
};

export const useNavigationConfigForTransactionDetails = ({
  transactionId,
  corporationId,
}: {
  transactionId: string;
  corporationId: string;
}) => {
  const items: BreadcrumbItemProps[] = [
    {
      label: 'Sales Tax',
      href: `/sales-tax/${corporationId}/transactions`,
    },
    {
      label: 'Transactions',
      href: `/sales-tax/${corporationId}/transactions`,
    },
    {
      label: transactionId,
      href: null,
    },
  ];

  return items;
};

export const useNavigationConfigForDataReview = ({
  corporationId,
}: {
  corporationId: string;
}) => {
  const items: BreadcrumbItemProps[] = [
    {
      label: 'Sales Tax',
      href: `/sales-tax/${corporationId}/transactions`,
    },
    {
      label: 'Address Validation',
      href: null,
    },
  ];

  return items;
};
